import React, { useState, useEffect, useCallback } from "react";
import { ScrollText } from "lucide-react";
import { PageHeader, SearchInput } from "../../ui";
import { FilterBar, FilterSelect } from "../../ui/FilterBar";
import AuditLogRow from "./AuditLogRow";
import apiClient from "../../../utils/apiClient";
import "./audit-logs.scss";

const ACTION_OPTIONS = [
  { value: "all", label: "All Actions" },
  { value: "create", label: "Create" },
  { value: "update", label: "Update" },
  { value: "delete", label: "Delete" },
  { value: "login", label: "Login" },
  { value: "logout", label: "Logout" },
  { value: "suspend", label: "Suspend" },
  { value: "reactivate", label: "Reactivate" },
  { value: "upgrade", label: "Upgrade" },
];

const ROLE_OPTIONS = [
  { value: "all", label: "All Roles" },
  { value: "tenantadmin", label: "Tenant Admin" },
  { value: "superadmin", label: "Super Admin" },
  { value: "admin", label: "Admin" },
  { value: "instructor", label: "Instructor" },
  { value: "student", label: "Student" },
  { value: "system", label: "System" },
];

const AuditLogsPage = () => {
  const [search, setSearch] = useState("");
  const [actionFilter, setActionFilter] = useState("all");
  const [roleFilter, setRoleFilter] = useState("all");
  const [logs, setLogs] = useState([]);

  const fetchLogs = useCallback(async () => {
    try {
      const params = {};
      if (actionFilter !== "all") params.action = actionFilter;
      if (roleFilter !== "all") params.role = roleFilter;
      if (search.trim()) params.search = search.trim();
      const res = await apiClient.get("/sa/audit-logs", { params });
      setLogs(res.data.logs || []);
    } catch { /* keep empty */ }
  }, [actionFilter, roleFilter, search]);

  useEffect(() => { fetchLogs(); }, [fetchLogs]);

  const filtered = logs;

  return (
    <div className="sa-audit-logs">
      <PageHeader
        title="Audit Logs"
        description="Track all platform-level actions and events"
        icon={ScrollText}
      />

      <FilterBar>
        <FilterSelect label="Action" value={actionFilter} onChange={setActionFilter} options={ACTION_OPTIONS} />
        <FilterSelect label="Role" value={roleFilter} onChange={setRoleFilter} options={ROLE_OPTIONS} />
        <SearchInput value={search} onChange={setSearch} placeholder="Search logs…" />
      </FilterBar>

      <div className="sa-card">
        <div className="sa-card-body p-0">
          <div className="sa-table-scroll">
            <table className="sa-mini-table w-100">
              <thead>
                <tr>
                  <th>Timestamp</th>
                  <th>User</th>
                  <th>Action</th>
                  <th>Description</th>
                  <th>Target</th>
                  <th>IP</th>
                </tr>
              </thead>
              <tbody>
                {filtered.length === 0 ? (
                  <tr>
                    <td colSpan={6} className="text-center text-muted py-4">
                      No audit logs found.
                    </td>
                  </tr>
                ) : (
                  filtered.map((log) => <AuditLogRow key={log._id} log={log} />)
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditLogsPage;
